<!--价格-->
<template>
  <div class="priceModule">
    <!--  价格  -->
    <div class="priceModule-price">
      <p v-if="priceType == 1">
        <span  class="priceSymbol">￥</span>
        <span  class="nowPrice">{{salePrice }}</span>
        <span v-if="courseBaseData.originalPrice" class="originalPrice">￥{{ courseBaseData.originalPrice }}</span>
      </p>
      <p v-if="priceType == 2">
        <span class="freeText">限时免费</span>
        <span v-if="courseBaseData.originalPrice" class="originalPrice">￥{{ courseBaseData.originalPrice }}</span>
      </p>
      <p v-if="priceType == 3">
        <span  class="priceSymbol">￥</span>
        <span  class="nowPrice">{{ salePrice }}</span>
      </p>
    </div>
    <!--  分期价格  -->
    <!-- <div class="priceModule-installment" v-if="canInstallment">
      <h3 class="installment-title">优惠</h3>
      <p class="installment-icon">分期付款</p>
      <span class="installment-content">分期支付 ¥ {{ by_stages_price }} 起</span>
    </div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    // priceType: { // 1:[现价 ，原价 ，购买人数]（原价课等）  2:[限时免费，原价 ，购买人数] (限时免费)  3:[现价 ，购买人数] (秒杀)
    //   type: [Number, String],
    //   default: 1,
    // },
    // by_stages_price: {
    //   // 分期价格
    //   type: [Number, String],
    // },
  },
  data() {
    return {
      // salePrice: '',
    };
  },
  computed: {
    ...mapState(['courseBaseData', 'productSku', 'allAcvitity']),
    priceType() {
      let priceType = 1;
      if (!this.salePrice) {
        // 2:[限时免费，原价 ，购买人数] (限时免费)
        priceType = 2;
      } else {
        // 1:[现价 ，原价 ，购买人数]（原价课等）
        priceType = 1;
      }
      return priceType;
    },
    // 当前售价
    salePrice() {
      const { sellPrice } = this.courseBaseData;
      const { nowAcvitity, activeType } = this.allAcvitity;
      const { price, productSkuId } = this.productSku;
      let salePrice = 0;
      if (!productSkuId) {
        // 售罄时展示产品中的价格
        salePrice = sellPrice;
      } else if (activeType <= 0 || activeType === 4 || nowAcvitity?.state === 0) {
        // 无活动-展示sku价格
        salePrice = price;
      } else {
        // 活动价格
        salePrice = nowAcvitity?.promotionPrice;
      }
      return salePrice;
    },
    // 是否可分期
    // canInstallment() {
    //   return this.salePrice >= 100;
    // },
  },
  watch: {
    // productSku(data) {
    //   // 获取sku的价格
    //   this.salePrice = data.productSkuId ? data.price : this.courseBaseData.sellPrice;
    // },
    // courseBaseData(data) {
    //   // 默认取产品的价格
    //   this.salePrice = data.sellPrice;
    // },
  },
  mounted() {
    // this.salePrice = this.courseBaseData.productId && this.courseBaseData.sellPrice;
  },
};
</script>

<style lang="scss" scoped>
.priceModule {

  .priceModule-price {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 36px 36px;
    border-radius: 0 0 14px 14px;
    $pubColor: #ff6c02;
    $pubGrayColor: #787878;

    > p {
      line-height: 33px;

      .priceSymbol {
        margin-left: -2px;
        padding-right: 4px;
        color: $pubColor;
        font-size: 22px;
      }

      .nowPrice {
        color: $pubColor;
        font-weight: 600;
        font-size: 33px;
      }

      .originalPrice {
        padding-left: 30px;
        color: $pubGrayColor;
        font-size: 25px;
        text-decoration: line-through;
      }

      .freeText {
        color: $pubColor;
        font-size: 36px;
      }

      .alreadyBuyNumber {
        color: $pubColor;
        font-size: 22px;
      }

      .alreadyBuyText {
        padding-left: 10px;
        color: #a5a5a5;
        font-size: 22px;
      }
    }
  }

  // .priceModule-installment {
  //   /* 分期 */
  //   display: flex;
  //   align-items: center;
  //   width: 100%;
  //   padding: 0 36px 36px;
  //   background: #fff;

  //   .installment-title {
  //     color: #333;
  //     font-weight: 600;
  //     font-size: 25px;
  //   }

  //   .installment-icon {
  //     display: flex;
  //     align-items: center;
  //     justify-content: center;
  //     width: 110px;
  //     height: 36px;
  //     margin: 0 26px 0 36px;
  //     color: #ff6c02;
  //     font-size: 22px;
  //     background: rgba(255, 126, 32, 0.15);
  //     border: 1px solid #ff6c02;
  //     border-radius: 4px;
  //   }

  //   .installment-content {
  //     color: #333;
  //     font-size: 25px;
  //     line-height: 36px;
  //   }
  // }
}
</style>
